import { FC, useState } from 'react';

import { Home, Menu, Search, ShoppingCart } from 'lucide-react';

import { CartSheet } from './shared/CartSheet';
import { MobileAccountDrawer } from './shared/MobileAccountDrawer';
import { useCart } from '../context/cart-context';
import { Routes } from '../models/routes';
import { CurrentUser } from '../types';
import components from './MobileBottomNav.components';

interface Props {
    currentUser: CurrentUser | null;
    onSearchClick?: () => void;
    newNotificationPresent?: boolean;
}

const { NavItem } = components;

export const MobileBottomNav: FC<Props> = ({
    currentUser,
    onSearchClick,
    newNotificationPresent,
}) => {
    const { cartCount } = useCart();
    const [menuOpen, setMenuOpen] = useState(false);
    const isAuthenticated = Boolean(currentUser);

    return (
        <>
            <div className="fixed right-0 bottom-0 left-0 z-50 border-t bg-background lg:hidden">
                <div className="grid h-16 grid-cols-4">
                    <NavItem
                        href={Routes.Home}
                        icon={<Home className="h-5 w-5" />}
                        label="Головна"
                    />
                    <NavItem
                        href="#"
                        icon={<Search className="h-5 w-5" />}
                        label="Пошук"
                        onClick={(e) => {
                            e.preventDefault();
                            onSearchClick?.();
                        }}
                    />

                    {isAuthenticated ? (
                        <CartSheet>
                            <NavItem
                                href="#"
                                icon={
                                    <div className="relative">
                                        <ShoppingCart className="h-5 w-5" />
                                        {cartCount > 0 && (
                                            <span className="absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-[10px] font-medium text-primary-foreground">
                                                {cartCount}
                                            </span>
                                        )}
                                    </div>
                                }
                                label="Кошик"
                            />
                        </CartSheet>
                    ) : (
                        <NavItem
                            href={Routes.SignIn}
                            icon={
                                <div className="relative">
                                    <ShoppingCart className="h-5 w-5" />
                                    <span className="absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-[10px] font-medium text-primary-foreground">
                                        0
                                    </span>
                                </div>
                            }
                            label="Кошик"
                        />
                    )}

                    <NavItem
                        icon={
                            <div className="relative">
                                <Menu className="h-5 w-5" />
                                {isAuthenticated && newNotificationPresent && (
                                    <span className="absolute -top-1 -right-2 h-3 w-3 animate-pulse rounded-full bg-yellow-400"></span>
                                )}
                            </div>
                        }
                        label="Меню"
                        onClick={() => setMenuOpen(true)}
                    />

                    <MobileAccountDrawer
                        open={menuOpen}
                        onClose={() => setMenuOpen(false)}
                    />
                </div>
            </div>

            <div className="h-16 md:hidden"></div>
        </>
    );
};
